export enum GameStatuses {
    Waiting = 0,
    FirstHalf = 1,
    SecondHalf = 2,
    EndOfFirstHalf = 3,
    PausedFirstHalf = -1,
    PausedSecondHalf = -2,
    PauseBetweenHalves = -3,
    EndOfGame = 6
}